export function getRoutes( state ) {
	return state.routes;
}
